import { Component, OnInit, ElementRef } from '@angular/core';
import { ProductCategoryService } from '../../services/product-category.service';
import { ModelModel } from '../../models/model.model';
import { ProductModel } from '../../models/product.model';
import { Subject } from "rxjs";

@Component({
  selector: 'app-model-details',
  templateUrl: './model-details.component.html',
  styleUrls: ['./model-details.component.css']
})
export class ModelDetailsComponent implements OnInit {
  model: ModelModel = new ModelModel();
  zip: string;
  product: ProductModel;
  modelNumber: string;
  rebatesInputEvent: Subject<any> = new Subject<any>();
  fullImagePath: string;
  iscommercial = 'false';
  productClass: string | null = null;
  eneryStarLogosString: string;
  eneryStarLogos: { Title: string, Image: string }[];
  energyStarDisclaimer: string | null = null;
  constructor(private service: ProductCategoryService, private hostElement: ElementRef) {}

  async ngOnInit() {
    try{
      const modelAtt = this.hostElement.nativeElement.getAttributeNode('model');
      const modelId: string = modelAtt && modelAtt.value ? modelAtt.value : '';
      const prodTypeAtt = this.hostElement.nativeElement.getAttributeNode('product');
      
      const prodTypeId: string = prodTypeAtt && prodTypeAtt.value ? prodTypeAtt.value : '';
  
      const lineAtt = this.hostElement.nativeElement.getAttributeNode('iscommercial');
      this.iscommercial = lineAtt && lineAtt.value ? lineAtt.value : 'false';
  
      const classAtt = this.hostElement.nativeElement.getAttributeNode('productClass');
      this.productClass = classAtt && classAtt.value ? classAtt.value : null;
  
      this.getproductbyId(prodTypeId, modelId);
      this.fullImagePath = '/angular/dist/assets/Locater.svg';
  
      const eneryStarLogosString = this.hostElement.nativeElement.getAttributeNode('eneryStarLogosString');

      const energyStarDisclaimerAttr = this.hostElement.nativeElement.getAttributeNode('energyStarDisclaimer');
      this.energyStarDisclaimer = energyStarDisclaimerAttr && energyStarDisclaimerAttr.value ? energyStarDisclaimerAttr.value : null;

      if (eneryStarLogosString && eneryStarLogosString.value && eneryStarLogosString.value.trim() != ''){
        const eneryStarLogosJsonString = eneryStarLogosString.value;
        const json = JSON.parse(eneryStarLogosJsonString);
        if (json){
          this.eneryStarLogos = json;
        }
      }
    }
    catch(ex) {
      console.log(ex);
    }
  }

  getproductbyId(Id: string, modelId: string){
    this.service.getPartialModelById(Id, modelId)
      .then(
        res => {
        if (res) {
          let retproduct: any;
          retproduct = res as any;
          this.product = retproduct ? new ProductModel(retproduct) : new ProductModel();
          this.model = this.product.models.find(x => {
            if (x.id === modelId) {
              return true;
            }
          });
          this.setModel();
        }
      }
    ).catch(err => console.log(err));
  }

  setModel = () => {
    this.modelNumber = this.model.modelNumber;
    // this.getRebateDetails();
  }

  // getRebateDetails(zip = null) {
  //   if (zip !== this.zip) {
  //     this.service.getRebateDetails(this.modelNumber, zip).subscribe(
  //       (response: any) => {
  //         this.rebatesInputEvent.next(response);
  //         this.zip = response.EcoRebatesResponse.area.zipCode;
  //       },
  //       (error: any) => {
  //         this.zip = zip;
  //         this.rebatesInputEvent.next(this.zip);
  //       }
  //     );
  //   }
  // }

  hasRelatedProducts(): boolean {
    const hasRelated = this.model && this.model.relatedAccessories && this.model.relatedAccessories.length > 0;
    if(! hasRelated ) {
      return false;
    }
    for(const prod of this.model.relatedAccessories) {
      if(prod.shouldDisplay(this.iscommercial, this.productClass)) {
        return true;
      }
    }
    return false;
  }

}



// WEBPACK FOOTER //
// ./src/app/product-category/containers/model-details/model-details.component.ts